import type { ListingPageResult } from '@/features/plp/domain/models/ProductListing';
import { mapRawDesignRecordsToListingDesignItems } from '@/features/plp/infra/mappers/plp.mapper';
import type {
  BrowsingHistoryCategoryList,
  BrowsingHistoryVisitorDataResponse,
} from '../../domain/models/BrowsingHistory';
import type {
  BrowsingHistoryCategoriesResponseDTO,
  BrowsingHistoryVisitorDataResponseDTO,
} from '../dto/browsingHistory.dto';

export const RECENTLY_VIEWED_HEADER = 'Recently Viewed Designs';

export function adaptVisitorDataDtoToDomain(
  dto: BrowsingHistoryVisitorDataResponseDTO,
): BrowsingHistoryVisitorDataResponse {
  return {
    browsingHistory: {
      browsingHistory: dto.browsingHistory?.browsingHistory ?? [],
      total: dto.browsingHistory?.total ?? 0,
      isProductPageExperimentEnable: dto.browsingHistory?.isProductPageExperimentEnable ?? null,
    },
  };
}

export function visitorDataDtoToListingPageResult(
  dto: BrowsingHistoryVisitorDataResponseDTO,
): ListingPageResult {
  return adaptVisitorDataToListingPageResult(adaptVisitorDataDtoToDomain(dto));
}

export function adaptCategoriesDtoToDomain(
  dto: BrowsingHistoryCategoriesResponseDTO,
): BrowsingHistoryCategoryList {
  return {
    categories: dto.categories ?? [],
  };
}

export function adaptVisitorDataToListingPageResult(
  dto: BrowsingHistoryVisitorDataResponse,
): ListingPageResult {
  const rawItems = dto.browsingHistory.browsingHistory ?? [];
  const designRecords = rawItems.map((item) => item.designItem);
  const designs = mapRawDesignRecordsToListingDesignItems(designRecords);

  return {
    header: RECENTLY_VIEWED_HEADER,
    totalCount: dto.browsingHistory.total ?? 0,
    filters: [],
    designs,
    listingSeo: {
      header: RECENTLY_VIEWED_HEADER,
      title: `Recently Viewed | BlueStone`,
      robotsMeta: 'noindex,nofollow',
    },
  };
}
